import styled from '@emotion/styled';
import { CSSProperties, ReactNode } from 'react';
import { Subtitle1 } from 'rwl-ui';

const StyledOverviewSection = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: var(--rwl-spacing-md);
`;

export const OverviewSection = ({
    title,
    style,
    children,
    titleStyle,
}: {
    title: string;
    style?: CSSProperties;
    children?: ReactNode;
    titleStyle?: CSSProperties;
}): JSX.Element => {
    return (
        <StyledOverviewSection style={{ ...style }}>
            <Subtitle1
                style={{
                    marginBottom: 'var(--rwl-spacing-sm)',
                    fontWeight: 600,
                    ...titleStyle,
                }}
            >
                {title}
            </Subtitle1>
            {children}
        </StyledOverviewSection>
    );
};
